import {Component, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {wholeNumberValidator} from "../../../components/validators/whole-number-validator";
import {ACCOUNT_LIMITS, ACCOUNT_TEXT_LIMITS} from "../../../constants/dataverse-field-limits";
import {storedMaxLengthValidator} from "../../../components/validators/stored-max-length-validator";
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {ContactMethodResponse} from "../../../models/Common/contactMethodResponse";
import {CommonService} from "../../../services/common.service";
import {CurrencyResponse} from "../../../models/Common/currencyResponse";
import {OrganizationService} from "../../../services/organization.service";
import swal from "sweetalert2";
import {RegistrationService} from "../../../services/register.service";
import {CountryResponse, IndustryResponse} from 'src/app/models/Common/countryResponse';
import {environment} from "../../../../environments/environment";
import {baseFile} from "../../../models/grantApplication/grantApplicationGetinfoResponse";
import Swal from "sweetalert2";




@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss'],
})


export class RegistrationFormComponent implements OnInit {
  contactMethods: ContactMethodResponse[] = [];
  currency: CurrencyResponse[] = [];
  counties: CountryResponse[] = [];
  /** account column ranges - see src/app/constants/dataverse-field-limits.ts */
  protected readonly accountLimits = ACCOUNT_LIMITS;
  /** account text column limits. This form posts multipart, so its textarea counts CRLF. */
  protected readonly accountTextLimits = ACCOUNT_TEXT_LIMITS;

  organizationForm: FormGroup = new FormGroup({
    organizeInfo: new FormGroup({
      name: new FormControl({value: '', disabled: true}),
      addressStreet: new FormControl('', [Validators.required, Validators.maxLength(ACCOUNT_TEXT_LIMITS.addressStreet)]),
      addressCity: new FormControl('', [Validators.required, Validators.maxLength(ACCOUNT_TEXT_LIMITS.addressCity)]),
      addressPostal: new FormControl('', [Validators.required, Validators.maxLength(ACCOUNT_TEXT_LIMITS.addressPostal)]),
      addressCountry: new FormControl('', Validators.required),
      webSiteUrl: new FormControl('', [Validators.maxLength(ACCOUNT_TEXT_LIMITS.webSiteUrl)]),
      annualBudget: new FormControl('', [Validators.required, wholeNumberValidator(),
        Validators.min(ACCOUNT_LIMITS.annualBudget.min), Validators.max(ACCOUNT_LIMITS.annualBudget.max)]),
      currencyId: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required, Validators.maxLength(ACCOUNT_TEXT_LIMITS.phone)]),
      numberOfEmployees: new FormControl('', [Validators.required, wholeNumberValidator(),
        Validators.min(ACCOUNT_LIMITS.numberOfEmployees.min), Validators.max(ACCOUNT_LIMITS.numberOfEmployees.max)]),
      description: new FormControl('', [Validators.required, storedMaxLengthValidator(ACCOUNT_TEXT_LIMITS.description)]),
      numberOfVoulenteers: new FormControl('',
        [
          Validators.required,
          wholeNumberValidator(),
          Validators.min(ACCOUNT_LIMITS.numberOfVoulenteers.min),
          Validators.max(ACCOUNT_LIMITS.numberOfVoulenteers.max)
        ]
      ),
      industry: new FormControl('', Validators.required),

      email: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    }),

    contactInfo: new FormArray(
      [this.createContactFormGroup()]
    ),
  });

  protected fileForm: FormGroup = new FormGroup({
    documentDatas: new FormArray([]),
  });

  get documentDatas(): FormArray {
    return this.fileForm.get('documentDatas') as FormArray;
  }


  industries: IndustryResponse[] = [];
  protected readonly environment = environment;
  files: baseFile[] = []

  constructor(private router: Router,
              private spinner: NgxSpinnerService,
              private organizationService: OrganizationService,
              private registrationService: RegistrationService,
              private commonService: CommonService) {
  }

  get contactInfoFormArray(): FormArray {
    return this.organizationForm.get('contactInfo') as FormArray;
  }

  loadIndustry() {
    return new Promise<void>((resolve, reject) => {
      this.commonService.getIndustriesEntity().subscribe({
        next: (response) => {
          this.industries = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading counties", error);
          reject(error);
        },
      });
    });
  }

  ngOnInit() {
    const organizationName = this.registrationService.getOrganizationName() || this.getCookie('organizationName');

    if (organizationName) {

      this.organizationForm.get('organizeInfo.name')?.setValue(organizationName);
      this.setCookie('organizationName', organizationName, 1);
    } else {
      this.router.navigate(['/registration']);
    }


    this.spinner.show();
    Promise.all([
      this.loadContactMethods(),
      this.loadCurrency(),
      this.loadCountry(),
      this.loadIndustry()
    ]).finally(() => this.spinner.hide());
  }

  setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  loadContactMethods() {
    return new Promise<void>((resolve, reject) => {
      this.commonService.getContactMethod().subscribe({
        next: (response) => {
          this.contactMethods = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact methods", error);
          reject(error);
        }
      });
    })

  }

  loadCurrency() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getCurrency().subscribe({
        next: (response) => {
          this.currency = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading currency methods", error);
          reject(error);
        }
      });
    })


  }

  loadCountry() {
    return new Promise<void>((resolve, reject) => {
      this.commonService.getCountryEntity().subscribe({
        next: (response) => {
          this.counties = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading country methods", error);
          reject(error);
        }
      });
    })
  }

  createContactFormGroup(): FormGroup {
    return new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      lastName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      position: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      email: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      phone: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      contactMethodId: new FormControl('', Validators.required),
    });
  }

  addContact() {
    this.contactInfoFormArray.push(this.createContactFormGroup());
  }

  removeContact(index: number) {
    this.contactInfoFormArray.removeAt(index);
  }



  async submitRegistrationForm(): Promise<void> {
    // Form validation
    if (this.organizationForm.invalid) {
      this.markAllAsTouched(this.organizationForm);
      await swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fill all the required fields correctly before submitting.'
      });
      return;
    }



    const nameControl = this.organizationForm.get('organizeInfo.name');
    if (nameControl?.disabled) {
      nameControl.enable();
    }

    // Prepare FormData for backend
    const formData = new FormData();

    // Prepare organizeInfo
    const organizeInfo = this.organizationForm.get('organizeInfo')?.value || {};
    // Add organizeInfo fields
    for (const key in organizeInfo) {
      if (organizeInfo.hasOwnProperty(key)) {
        formData.append(`organizeInfo.${key}`, organizeInfo[key]);
      }
    }

    // Prepare contactInfo array
    if (this.contactInfoFormArray.length === 0) {
      await swal.fire({
        icon: 'error',
        title: 'Contact Information Required',
        text: 'Please add at least one contact person before submitting.'
      });
      return;
    }

    this.contactInfoFormArray.value.forEach((contact: any, index: number) => {
      for (const key in contact) {
        if (contact.hasOwnProperty(key)) {
          formData.append(`contactInfo[${index}].${key}`, contact[key]);
        }
      }
    });

    // Check and append the assessment file, if available
    if (this.documentDatas.length > 0 && this.documentDatas.controls.some(control => control.value.file)) {
      const fileControl = this.documentDatas.controls.find(control => control.value.file);
      if (fileControl) {
        formData.append('organizeInfo.AssessmentFormFile', fileControl.value.file, fileControl.value.file.name);
      }
    } else {
      await Swal.fire({
        icon: 'warning',
        title: 'File Attachment Required',
        text: 'Please attach an Assessment file before submitting the application.',
      });
      return;
    }


    await this.spinner.show();

    // Submit data via service
    this.organizationService.submit(formData).subscribe({
      next: async (response) => {
        await this.spinner.hide();
        if (response.result) {
          this.deleteCookie('organizationName');
          await swal.fire({
            title: 'Your organization form has been successfully submitted. \n A member of our team will review your details and contact you shortly via the email address you provided',
            icon: 'success',
            confirmButtonText: 'OK',
            width: '900px'
          });
          await this.router.navigate(['/registration-result']);
        } else {
          await swal.fire({
            title: response.messages?.join(','),
            icon: 'error',
            confirmButtonText: 'OK'
          });
          await this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error submitting the organization form.', error);
      }
    });
  }
  private appendFileToFormData(formData: FormData, file: File): void {
    formData.append('AssessmentFormFile', file, file.name);
  }
  deleteCookie(name: string) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  }
  markAllAsTouched(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key) => {
      const control = group.get(key);

      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllAsTouched(control);
      }
    });
  }
}
